import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Loader, isSubscriptionActive, shouldShowPaymentAlert } from '../../utils/tools';
import PaymentAlert from '../../utils/paymentAlert';

import { getEvidenceList } from '../../store/actions/evidenceList';
import { resetCurrentEvidenceList } from '../../store/reducers/evidenceList';

// COMPONENTS
import ShowWaste from './waste/show';
import CustomModalInline from '../../hoc/customModalInline';
import ExportEvidenceSheetToPdf from './exportToPdf';
import LastYearBalance from './lastYearBalance';
import IncomeDisposal from './incomeDisposal';

import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';

// Používa sa buď cez route (/evidencelist/:id, bez props) alebo ako modal z listu
// evidenčných listov (id + onClose ako props, viď PackagingUnitDetail v PPWR).
const Detail = ({ id: idProp, onClose: onCloseProp } = {}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const params = useParams();
    const isModal = !!idProp;
    const id = idProp || params.id;

    const tenant = useSelector(state => state.tenant.current);
    const isActive = isSubscriptionActive(tenant?.subscriptionStatus, tenant?.plan);

    const loading = useSelector(state => state.evidenceList.currentLoading);
    const currentBranch = useSelector(state => state.branch.current);
    const currentEvidenceList = useSelector(state => state.evidenceList.current)

    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const initialBranchRef = useRef(currentBranch);
    const safeBranchId = currentBranch === initialBranchRef.current ? currentBranch : null;

    useEffect(() => {
        return () => {
            dispatch(resetCurrentEvidenceList());
        };
    }, []);

    useEffect(() => {
        if (!currentBranch || currentBranch !== initialBranchRef.current) {
            if (isModal) { onCloseProp?.(); } else { navigate('/dashboard'); }
            return;
        }

        if (id) {
            dispatch(getEvidenceList({ id, currentBranch }))
                .then(response => {
                    if (response.error) {
                        if (isModal) { onCloseProp?.(); } else { navigate('/evidencelist'); }
                    }
                });
        }
    }, [currentBranch, id]);


    const handleCloseExportModal = () => {
        setIsExportModalVisible(false);
    };

    const handleExportButtonClick = () => {
        setIsExportModalVisible(true);
    };

    return(
        <>
           {loading || !currentEvidenceList || !currentEvidenceList.wasteCode ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '35vh',
                    }}
                >
                    <Loader />
                </div>
            )  :
                <div>

                    {tenant && shouldShowPaymentAlert(tenant.subscriptionStatus, tenant.plan) && (
                        <PaymentAlert status={tenant.subscriptionStatus} plan={tenant.plan} />
                    )}

                    <div className="content p-4 mb-4">

                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                                <h4 className="mb-0">{currentEvidenceList.name}</h4>
                                <span style={{ fontSize: '13px', color: '#8492a6' }}>{currentEvidenceList.wasteCode.wasteName}</span>
                            </div>
                            <OverlayTrigger
                                placement="left"
                                overlay={<Tooltip>Exportovať do PDF</Tooltip>}
                            >
                                <button className="export-icon-btn" onClick={handleExportButtonClick}>
                                    <FaFilePdf size={20} />
                                </button>
                            </OverlayTrigger>
                        </div>

                        <Row className="text-center pb-2">
                            <Col>
                                <div>
                                    <span className="evidence-meta-label">Kód odpadu</span>
                                </div>
                                <div>
                                    <strong>{currentEvidenceList.wasteCode.wasteCode}</strong>
                                </div>
                            </Col>

                            <Col xs="auto" className="d-flex align-items-center">
                                <div style={{ width: "1px", height: "100%", backgroundColor: "#ddd" }} />
                            </Col>

                            <Col>
                                <div>
                                    <span className="evidence-meta-label">Kód činnosti</span>
                                </div>
                                <div>
                                    <strong>{currentEvidenceList.activityCode}</strong>
                                </div>
                                {currentEvidenceList.activityCode === 'R' && currentEvidenceList.primaryLoadingCode && (
                                    <div className="mt-1">
                                        <div style={{ fontSize: '10px', color: '#a0aec0', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>
                                            Primárny kód nakladania
                                        </div>
                                        <span style={{
                                            display: 'inline-block',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            color: '#3182ce',
                                            backgroundColor: '#ebf8ff',
                                            border: '1px solid #bee3f8',
                                            borderRadius: '4px',
                                            padding: '1px 7px',
                                        }}>
                                            {currentEvidenceList.primaryLoadingCode}
                                        </span>
                                    </div>
                                )}
                            </Col>

                            <Col xs="auto" className="d-flex align-items-center">
                                <div style={{ width: "1px", height: "100%", backgroundColor: "#ddd" }} />
                            </Col>

                            <Col>
                                <div>
                                    <span className="evidence-meta-label">Y kód</span>
                                </div>
                                <div>
                                    <strong>{currentEvidenceList.yCode || '-'}</strong>
                                </div>
                            </Col>

                            <Col xs="auto" className="d-flex align-items-center">
                                <div style={{ width: "1px", height: "100%", backgroundColor: "#ddd" }} />
                            </Col>

                            <Col>
                                <div>
                                    <span className="evidence-meta-label">ZPR (t)</span>
                                    <div>
                                        <strong>
                                            <LastYearBalance branchId={safeBranchId} />
                                        </strong>
                                    </div>
                                </div>
                            </Col>

                            <Col xs="auto" className="d-flex align-items-center">
                                <div style={{ width: "1px", height: "100%", backgroundColor: "#ddd" }} />
                            </Col>

                            <Col>
                                <div className="evidence-meta-secondary">
                                    <span className="evidence-meta-label-sm">Posledná úprava</span>
                                    <div className="evidence-meta-value-sm">{currentEvidenceList.editedBy}</div>
                                </div>
                            </Col>
                        </Row>

                        <div style={{ height: "1px", width: "100%", backgroundColor: "#ddd" }} />

                        <Row className="pt-2">
                            {/* Income, Disposal & Balance */}
                            <IncomeDisposal branchId={safeBranchId} />
                        </Row>
                        
                    </div>
                
                    <ShowWaste
                        evidenceListId={id}
                        branchId={safeBranchId}
                    />

                    {/* Panel for export Evidence sheet */}
                    <CustomModalInline isVisible={isExportModalVisible} onClose={handleCloseExportModal} >
                        <ExportEvidenceSheetToPdf onClose={handleCloseExportModal} id={id} branchId={currentBranch}/>
                    </CustomModalInline>

                </div>
            }
        </>
    )
}

export default Detail;

